import { z } from 'zod';

import { PmsType } from '../pms/pms';

export const PaymentDetailSchema = z.object({
  lastName: z.string().optional(),
  methodNumber: z.string().optional(),
  pmsType: z.nativeEnum(PmsType).optional(),
  reservationId: z.union([z.number().transform((id) => `${id}`), z.string()]).optional(),
  confirmationId: z.string().optional(),
  collectionDetail: z.string().optional(),
});
